// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5e68e8bf","268":"24033bdd","457":"b2c29c37","551":"042b74cc","667":"a04d7bd3","828":"e06d6a52","950":"b02c92a7"}[chunkId] + ".chunk.js";
};